import store from 'store'
import { initSocket, removeSocket } from '../../../../shared/apis/savor-server.api'
import { clearOutlets } from '../../../../shared/models/outlets.model'

const Authentication = {
  isAuthenticated: false,
  logginIfLogged() {
    const user = store.get('user')
    const currentShift = store.get('currentShift')
    if (user && user._id) {
      this.isAuthenticated = true
    }
    return { user, currentShift }
  },
  getCurrentShift() {
    return store.get('currentShift')
  },
  getUser() {
    return store.get('user')
  },
  setUser(user) {
    store.set('user', user)
    if (user && user._id) {
      this.isAuthenticated = true
    } else {
      this.isAuthenticated = false
    }
  },
  setCurrentShift(shiftRecord) {
    if (!shiftRecord) {
      throw new Error('Server không trả về ca trực. Kiểm tra lại cơ sở và thử đăng nhập lại.')
    }
    store.set('currentShift', shiftRecord)
    initSocket(shiftRecord.shiftRecordId)
  },
  logout() {
    store.remove('user')
    store.remove('currentShift')
    clearOutlets()
    this.isAuthenticated = false
    removeSocket()
  }
}

export default Authentication
